








































import { Component, Mixins, Watch } from "vue-property-decorator";
import { ExternalDataItem } from "../../../../domain/document/items";
import {
  IConfiguration,
} from "../../../../domain/configuration";
import { IObjectStyleReadable } from "../IObjectStyleReadable";
import { ExternalDataObjectStyleReader } from "../styleReaders";
import {
  StyledTextEditableObjectMixin,
  DataValidatableMixin
} from "./mixins";
import TextInputArea from "./TextInputArea.vue";
import { IFreeInputableObject } from "./IFreeInputableObject";

@Component({
  components: {
    TextInputArea,
  }
})

// 暫定で追加したのみの状態
// V1フォーマット上ではscriptタグ
// [参考資料]
// \\192.168.2.222\共通フォルダ他\★Documaker\01_DocuMaker導入資料\機能仕様書\機能別\外部データ一覧選択.docx
export default class ExternalDataObject extends Mixins(
  StyledTextEditableObjectMixin,
  DataValidatableMixin
) implements IFreeInputableObject {
  get editStyleReader(): IObjectStyleReadable {
    const configuration = this.$store.getters.configuration as IConfiguration;
    return new ExternalDataObjectStyleReader(configuration.style.document.editor.objects.externalData);
  }

  editingSource: ExternalDataItem;

  updateInputElement(value: HTMLInputElement): void {
    this.inputableElement = value;
  }

  @Watch("isFocused")
  updateIsFocused(newValue: boolean, oldValue: boolean): void {
    if (!newValue) {
      this.adjustTextFontSize();
    }
  }

  get displayText(): string {
    return this.shouldInputFreeSelfOrAll ? this.freeInputText
      : this.isObjectNameDisplay ? this.objectName
      : this.freeInputText;
  }

  set displayText(value: string) {
    this.freeInputText = value;
  }

  get displayMeasureText(): string {
    this.updateTextPositionHeight();
    return this.textPositionCompositing
      ? this.textPositionMeasureText
      : this.displayText;
  }

  get objectName(): string {
    return this.editingSource.name + "[" + this.editingSource.row + "][" + this.editingSource.column + "]";
  }

  get isObjectNameDisplay(): boolean {
    return this.editingSource.isEmpty;
  }

  get title(): string {
    return this.toolTip
      ? this.toolTip
      : this.editingSource.name;
  }

  focusToObjectNameDisplay(): void {
    const container = this.$refs.objectNameContainer as HTMLDivElement;
    if (!container) { return; }
    container.focus();
    this.emitFocus();
  }

  showDialogIfNeeded(): void {
    if (!this.shouldInputFreeSelfOrAll) {
      this.commonComponents.adapters.externalScript.executeExternalData(this.editingSource)
      .catch(e => {
        this.$error("エラー", "外部データ実行中にエラーが発生しました。", e);
      });
    }
  }
  
  get freeInputText(): string {
    return this.editingSource.value;
  }

  set freeInputText(value: string) {
    this.writeProperty(s => s.value = this.validateText(this.editingSource, value));
  }

  adjustTextFontSize(): void {
    if (!this.editingSource.isEmpty) {
      this.autoAdjustFontSize();
    }
  }

  @Watch("shouldInputFree")
  updateShouldInputFree(newValue: boolean, oldValue: boolean): void {
    this.showDialogIfNeeded();
  }

  get isMultiLine(): boolean {
    return this.editingSource.isMultiLine;
  }

  pasteText(value: string): void {
    this.insertTextToCaretPosition(value);
    this.$nextTick(() => {
      this.adjustTextFontSize();
    });
  }

  overwriteText(value: string, isForcibly?: boolean): void {
    console.error("overwriteTextは実装されていません。");
  }
}
